/**
 * Modern Auth layout for login/register pages
 */

import { Outlet, Link, Navigate } from 'react-router-dom';
import { Trophy } from 'lucide-react';
import { useAppStore } from '../../stores/appStore';
import { useRouteFocus } from '../../hooks/useRouteFocus';
import ThemeToggle from '../ui/ThemeToggle';
import SkipToContent from './SkipToContent';

export default function AuthLayout() {
  const isAuthenticated = useAppStore((state) => state.isAuthenticated);

  useRouteFocus();

  // Redirect to dashboard if already authenticated
  if (isAuthenticated) {
    return <Navigate to="/inicio" replace />;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-500 via-primary-600 to-accent-600 dark:from-primary-700 dark:via-primary-800 dark:to-accent-800 flex flex-col transition-colors">
      <SkipToContent />
      {/* Header */}
      <header className="p-6 flex items-center justify-between">
        <Link to="/" className="inline-flex items-center gap-3 text-white hover:opacity-80 transition-opacity group">
          <div className="w-10 h-10 rounded-xl bg-white/20 backdrop-blur-md flex items-center justify-center shadow-lg group-hover:bg-white/30 transition-colors">
            <Trophy className="w-5 h-5 text-white" />
          </div>
          <span className="font-bold text-xl">Bolão 2026</span>
        </Link>
        <ThemeToggle className="text-white/70 hover:text-white hover:bg-white/10" />
      </header>

      {/* Main content */}
      <main id="main" tabIndex={-1} className="flex-1 flex items-center justify-center p-6 focus:outline-none">
        <div className="w-full max-w-md">
          <div className="bg-white dark:bg-neutral-900 rounded-2xl shadow-2xl dark:shadow-dark-lg p-8 border border-white/10 dark:border-neutral-800 transition-colors">
            <Outlet />
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="p-6 text-center text-white/70 text-sm">
        <p>Copa do Mundo FIFA 2026</p>
      </footer>

      {/* Background decoration */}
      <div className="fixed inset-0 -z-10 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-secondary-400/20 rounded-full blur-3xl" />
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-accent-400/20 rounded-full blur-3xl" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-primary-300/10 rounded-full blur-3xl" />
      </div>
    </div>
  );
}
